export default __webpack_public_path__ + "static/media/mann-solar-logo.907b85f5.png";